import { render, staticRenderFns } from "./ViewSchool.vue?vue&type=template&id=9cb521ea&"
import script from "./ViewSchool.vue?vue&type=script&lang=js&"
export * from "./ViewSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports